import React, { useState } from 'react';
import { Box, Typography, Button, Dropdown } from '@lucid/lego';
import styles from './AlertDetails.module.scss';

type WorkOrderOption = {
  value: string;
  label: string;
};

type WorkOrderSelectionProps = {
  theme: 'light' | 'dark';
  onBack: () => void;
  onSubmit: (workOrderId: string) => void;
  isSubmitting: boolean;
};

// Mock work order data - replace with actual API call later
const mockWorkOrders: WorkOrderOption[] = [
  { label: 'WO-123-Engine-Repair', value: 'f47ac10b-58cc-4372-a567-0e02b2c3d479' },
  { label: 'WO-124-Tire-Replacement', value: 'a1b2c3d4-5678-90ab-cdef-123456789012' },
  { label: 'WO-125-Battery-Service', value: 'b2c3d4e5-6789-01bc-def1-234567890123' },
  { label: 'WO-126-Brake-Inspection', value: 'c3d4e5f6-7890-12cd-ef12-345678901234' },
];

const WorkOrderSelection: React.FC<WorkOrderSelectionProps> = ({
  theme,
  onBack,
  onSubmit,
  isSubmitting,
}) => {
  const [selectedWorkOrder, setSelectedWorkOrder] = useState<string>('');

  const handleSubmit = () => {
    if (selectedWorkOrder) {
      onSubmit(selectedWorkOrder);
    }
  };

  return (
    <Box className={styles.workOrderContainer}>
      <Box className={styles.workOrderHeader}>
        <Typography variant="headline" size="small" theme={theme} color="primary-1">
          Select Work Order
        </Typography>
        <Box mt={8}>
          <Typography variant="body" size="medium" theme={theme} color="gray-3">
            Choose a work order to associate with this alert resolution.
          </Typography>
        </Box>
      </Box>

      <Box mt={24}>
        <Dropdown
          label="Work Order"
          placeholder="Select a work order..."
          options={mockWorkOrders}
          selectedOption={selectedWorkOrder}
          handleSelect={(value) => setSelectedWorkOrder(value)}
          theme={theme}
          size="medium"
        />
      </Box>

      <Box className={styles.workOrderFooter}>
        <Button
          label="Back"
          size="medium"
          theme={theme}
          onClick={onBack}
          disabled={isSubmitting}
          gaComponent="work-order-back"
          dataTestId="work-order-back-button"
        />
        <Button
          label={isSubmitting ? 'Resolving...' : 'Resolve Alert'}
          size="medium"
          theme={theme}
          onClick={handleSubmit}
          disabled={!selectedWorkOrder || isSubmitting}
          gaComponent="work-order-submit"
          dataTestId="work-order-submit-button"
        />
      </Box>
    </Box>
  );
};

export default WorkOrderSelection;
